import styled from "styled-components"
import { device } from "../mediaQuery/mediaQuery"

type LabelStyled = {
  isSelected: boolean;
  gradientColor:string;
}

export const Container = styled.div`
  margin-bottom: 100px;
`

export const Wrap = styled.div`
  @media ${device.tablet} {
  }
  @media ${device.desktop} {
    display: flex;
  }
`
export const LabelArea = styled.div`
  display: flex;
  justify-content: center;

  @media ${device.tablet} {
    margin-bottom: 10px;
    flex-wrap:wrap;
    flex-direction: row;

  }
  @media ${device.desktop} {
    margin-right: 1%;
    margin-bottom: 0;
    flex-direction: column;
  }
`
export const Label = styled.button<LabelStyled>`
  border: 2px solid
    ${props => (props.isSelected ? props.gradientColor : `#b8b8b8`)};
  background-color: ${props => (props.isSelected ? props.color : `#cecece`)};
  border-radius: 5px;

  padding: 10px;
  color: white;
  font-size: 24px;
  font-weight: bold;
  text-align: center;
  cursor: pointer;
  width: 140px;

  @media ${device.tablet} {
    display: inline-block;
    margin-right: 10px;
    margin-bottom: 10px;
  }
  @media ${device.desktop} {
    display: block;
    margin-bottom: 10px;
    :hover {
      color: white;
      background-color: ${props => props.color};
      border: 2px solid ${props => props.gradientColor};
    }
  }
`
